import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PermissionStates } from '../../permission-controller/root';
import { PermSetStates } from '../states';
import { permSetAdapters, PermSetState } from '../states/perm-set.states';

export const permSetFeatureKey = 'permSet';

export const selectPermSetFeature = createFeatureSelector<PermSetState>(permSetFeatureKey);

export const selectNewPermSet = (state: PermissionStates) => state.permissions.permSet.newPermSet;
export const selectPermSet = (state: PermissionStates) => state.permissions.permSet.selectedPermSet;
export const selectPermTemplate = (state: PermissionStates) => state.permissions.permSet.selectedPermTemplate;
export const selectPermSetLine = (state: PermissionStates) => state.permissions.permSet.selectedPermSetLine;

export const selectUpdatePermSetListing = (state: PermissionStates) => state.permissions.permSet.updatePermSetListing;

export const selectGuid = (state: PermissionStates) => state.permissions.permSet.selectedGuid;
export const selectViewCache = (state: PermissionStates) => state.permissions.permSet.viewCache;
export const selectRequiresUpdate = (state: PermissionStates) => state.permissions.permSet.requiresUpdate;

// This is an example of how to combine selectors
// export const combinedSelectors = createSelector(
//   selectGuid,
//   selectRemoveState,
//   (guid, onRemove) => ({guid, onRemove})
// )

export const {
    selectIds,
    selectEntities,
    selectAll,
    selectTotal
} = permSetAdapters.getSelectors(selectPermSetFeature);
